import React from 'react';

interface PastDatesToggleProps {
  showPastSchedules: boolean;
  onToggle: (show: boolean) => void;
}

const PastDatesToggle: React.FC<PastDatesToggleProps> = ({ showPastSchedules, onToggle }) => {
  return (
    <div className="absolute right-0 top-1/2 -translate-y-1/2">
      <label className="flex items-center gap-2.5 cursor-pointer group px-3 py-1.5 rounded-lg hover:bg-gray-900/30 transition-colors">
        <span className="text-sm text-gray-400 group-hover:text-gray-300 transition-colors font-bold tracking-wider">
          Past Dates
        </span>
        <div className="relative">
          <input
            type="checkbox"
            checked={showPastSchedules}
            onChange={(e) => onToggle(e.target.checked)}
            className="sr-only"
          />
          <div className={`w-8 h-4 rounded-full transition-all duration-200 ${
            showPastSchedules ? 'bg-blue-500' : 'bg-gray-700/60'
          }`}>
            <div className={`absolute top-0.5 w-3 h-3 bg-white rounded-full transition-all duration-200 ${
              showPastSchedules ? 'translate-x-4' : 'translate-x-0.5'
            }`} />
          </div>
        </div>
      </label>
    </div>
  );
};

export default PastDatesToggle;
